import { render } from "./OtiClock.vue?vue&type=template&id=b66b8180&scoped=true"
import script from "./OtiClock.vue?vue&type=script&lang=js"
export * from "./OtiClock.vue?vue&type=script&lang=js"

import "./OtiClock.vue?vue&type=style&index=0&id=b66b8180&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66b8180"]])

export default __exports__